/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useContext, useEffect, useState } from 'react';
import { RootContext } from '../../hoc/RootContext/RootContext';
import axios from "../../utils/axios";
import { Spinner } from 'react-bootstrap';
import {
  getRequestedAdminPath,
  redirectToIdCloudLogin,
  resolveActiveAuth
} from '../../auth/session';

const PrivateRoute = ({ children }) => {
  const [isBootstrapping, setIsBootstrapping] = useState(true);

  const {
    authToken,
    setAuthToken,
    authSource,
    setAuthSource,
    currentUser,
    setCurrentUser
  } = useContext(RootContext);

  const clearLocalAuth = () => {
    setAuthToken(null);
    setAuthSource(null);
    setCurrentUser(null);
  };

  useEffect(() => {
    let isMounted = true;

    const bootstrapAuth = async () => {
      if (currentUser?.is_id360_admin || currentUser?.is_id360_user) {
        if (isMounted) setIsBootstrapping(false);
        return;
      }

      const requestedPath = getRequestedAdminPath();
      const activeAuth = await resolveActiveAuth();
      if (!isMounted) return;

      if (!activeAuth.token) {
        clearLocalAuth();
        redirectToIdCloudLogin(requestedPath);
        return;
      }

      if (authToken !== activeAuth.token) {
        setAuthToken(activeAuth.token);
      }

      if (authSource !== activeAuth.source) {
        setAuthSource(activeAuth.source);
      }

      try {
        const result = await axios.post(
          '/login',
          { token: activeAuth.token },
          { headers: { 'x-access-token': activeAuth.token } }
        );

        if (!isMounted) return;

        if (result.status === 200) {
          const { user } = result.data;
          if (user.is_id360_admin || user.is_id360_user) {
            setCurrentUser(user);
            setIsBootstrapping(false);
            return;
          }
        }
      } catch (e) {
        // fall through to auth reset + redirect
      }

      clearLocalAuth();
      redirectToIdCloudLogin(requestedPath);
    };

    bootstrapAuth();

    return () => {
      isMounted = false;
    };
  }, [currentUser]);

  if (currentUser?.is_id360_admin || currentUser?.is_id360_user) {
    return children;
  }

  if (isBootstrapping) {
    return (
      <div className="d-flex justify-content-center my-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return null;
};

export default PrivateRoute;
